import { render, staticRenderFns } from "./editFeeConfig.vue?vue&type=template&id=9df87f72&scoped=true"
import script from "./editFeeConfig.vue?vue&type=script&lang=js"
export * from "./editFeeConfig.vue?vue&type=script&lang=js"
import style0 from "./editFeeConfig.vue?vue&type=style&index=0&id=9df87f72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9df87f72",
  null
  
)

export default component.exports